import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSunIconSecondary from './svgs/SunIconSecondary.js';
import SvgSunIcon from './svgs/SunIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sunIcon = (props => useIcon(SvgSunIcon, SvgSunIconSecondary, props));

export { sunIcon as default };
